'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _matches = require('./matches');
var _matches2 = _interopRequireDefault(_matches);
var _required = require('./required');
var _required2 = _interopRequireDefault(_required);
var _oneByOne = require('./one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_ref) {
    var value = _ref.value;
    return value ? 'Please enter a valid name' : 'Please enter your name';
  };
  var extraOptions = arguments[1];
  return (0, _oneByOne2.default)((0, _required2.default)(errorMessage, extraOptions), (0, _matches2.default)(/^[a-zA-Z '-]+$/, errorMessage, extraOptions));
};